class MiniCart {
    constructor() {
        this.cartButton = document.getElementById('cart-icon-bubble');
        this.miniCart = document.getElementById('mini-cart');
        this.miniOverlay = document.getElementById('mini-overlay');
        this.openCart();
        this.closeCartButton = document.getElementById('close__cart');
        this.closeCart();
    }

    openCart() {
        let open = this.miniCart;
        let openOverlay = this.miniOverlay;
        this.cartButton.addEventListener('click', () => {
            open.classList.remove('translate-x-[100%]')
            open.classList.add('translate-x-[0]')

            openOverlay.classList.remove('translate-x-[100%]')
            openOverlay.classList.add('translate-x-[0]')

        })
    }

    closeCart() {
        let close = this.miniCart;
        let closeOverlay = this.miniOverlay;
        this.closeCartButton.addEventListener('click', () => {
            close.classList.remove('translate-x-[0]');
            close.classList.add('translate-x-[100%]');

            closeOverlay.classList.remove('translate-x-[100%]')
            closeOverlay.classList.add('translate-x-[0]')
        })
    }

}

const Cart = new MiniCart();

